import "../../components/css/News.css";
import PageTitle from "../../components/pagetitle/PageTitle";
import gambar6 from "../../Images/News/MCC.WebP";

function News6() {
  return (
    <>
      <PageTitle motherMenu="Media Coverage" menuback="Previous Page" backbtn="/PageNewsList" activeMenu="" />
      <div className="mt-5">
        <section className="feature section pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 ml-auto justify-content-center">
                {/* <!-- About Mockup --> */}

                {/* <div className="image-content" data-aos="fade-right"> */}
                <img className="img-fluid" src={gambar6} alt="" />
                {/* </div> */}
              </div>
              <div className="col-lg-6 ">
                <div className="feature-content">
                  {/* <!-- About Title --> */}

                  <h2>
                    5 students of SMA Negeri 4 Denpasar won the "Best Poster"
                    award and "Gold Medal" of Innovation Science YISF 2024
                  </h2>

                  {/* <!-- About Description -->} */}

                  <p className="desc">
                    <br></br>
                    A pride for 5 outstanding students who from SMA Negeri 4
                    Denpasar, because they managed to win two awards at once at
                    the YISF (Youth International Science Fair) held by IYSA
                    (Indonesia Young Scientist Association). The awards achieved
                    are "Best Poster" and also "Gold Medal" in the field of
                    Innovation Science. With high enthusiasm and determination
                    to make the scientific work of a team of 5 students can
                    participate in the YISF (Youth International Science Fair)
                    and won.
                    <br />
                    <br />
                    IYSA is an organization that often holds events for
                    scientific scientific work competitions from the national
                    and international scope. And YISF is one of the events held
                    by IYSA, this year IYSA is holding the 4th YISF event for
                    the 4th time and was held in a hybrid competition, namely
                    online and offline. The process The participation process
                    that these 5 students went through was not easy, the stages
                    begin with preparing the research results first, namely the
                    team made "CEATHUCINE" which is a an edible spoon to prevent
                    stunting in children under five years old, then the team
                    registered as a participant in the YISF competition offline
                    in Malang.
                    <br />
                    <br />
                    After registration, the next stage is judging which held on
                    February 28, which began with opening ceremony at Malang
                    Creative Center then continued on February 29, namely the
                    judging stage which is where we from the SMA NEGERI 4
                    DENPASAR team prepared a booth and also the results of the
                    research that will be presented to the jury. The judging
                    process used English language because this YISF is an
                    international event, which is which was attended by 11
                    countries with 111 teams from all over the world. countries.
                    <br />
                    <br />
                    Accompanied by supervising teacher Ni Made Margiani, the
                    five students, namely Anak Agung Gede Pemayun Mahesa
                    Wydarma, Ni Putu Astawa Lastari Dewi, Kadek Radharanie Shira
                    Supraba Putri Hartawan, A.A Ayu Mirah Indriani, Made Arya
                    Saskara Putra Dewata confidently presented their his work in
                    front of the jury. Question after question successfully
                    answered by the team with great detail and weighty. Until
                    the announcement of the best results on March 2, coinciding
                    with the awarding ceremony and the SMA NEGERI 4 DENPASAR
                    team received the "Best Poster" award and also "Gold Medal"
                    in the field of Innovation Science.
                    <br />
                    <br />
                    Agung Mahesa, one of the students who participated in this
                    event revealed the reason for participation in this event,
                    because events held by IYSA itself have been curated by
                    Puspresnas and we from the by Puspresnas and we are from the
                    SMA Negeri 4 Denpasar team very enthusiastic to participate
                    in the 4th YISF event this time offline and also to add to
                    our experience in the field of scientific work. "The results
                    we achieved are the result of "The results we achieved are
                    the result of extraordinary teamwork. the best in this event
                    we have succeeded in realizing which of course making the
                    school proud. Thank you to all those who supported us until
                    we managed to achieve the best title," said Mahesa.
                    <br />
                    <br />
                    The accompanying teacher who always accompanies during the
                    competition that The 5 students are also proud of their
                    achievements. achievement of his students. "We did not
                    expect that our students managed to achieved the "Best
                    Poster" achievement and also the "Gold Medal" in the
                    Innovation Science, bringing pride to the school. school. We
                    hope this achievement does not stop here, we will also
                    develop the children's work again so that it is not just
                    participating in the competition but the results of this
                    work can be useful for the surrounding community, "said Ni
                    Made Margiani.
                    <br />
                    <br />
                  </p>
                  <p>
                    Source :{" "}
                    <a
                      href="https://pancarpos.com/27/03/2024/keren-5-siswa-sma-negeri-4-denpasar-raih-penghargaan-best-poster-dan-gold-medali-innovation-science-yisf/#google_vignette"
                      target="_blank"rel="noreferrer"
                    >
                      click here
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default News6;
